import { ReactNode } from "react";
import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  children?: ReactNode;
  className?: string;
}

const FeatureCard = ({ icon: Icon, title, description, children, className }: FeatureCardProps) => {
  return (
    <div className={cn("rounded-lg border border-border bg-card p-6", className)}>
      <div className="flex items-start gap-4">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-primary/10">
          <Icon className="h-5 w-5 text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="mb-1 font-semibold text-foreground">{title}</h3>
          <p className="mb-4 text-sm text-muted-foreground">{description}</p>
          {children}
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;
